import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import {BehaviorSubject, Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {map, tap} from 'rxjs/operators';
import {ApiService} from '../api/api.service';
import {Evaluation} from '../models/models.lib';

const { apiUrl } = environment;

export abstract class CasiEvaluationService extends BehaviorSubject<Array<any>>{
  public loading: boolean = false;

  constructor(
    private http: HttpClient,
  ) {
    super([]);
  }

  public query(): void {
    this.fetch().subscribe((x) => {
      return super.next(x);
    });
  }

  protected fetch(): Observable<Evaluation[]> {
    this.loading = true;

    return this.http.get(encodeURI(`${apiUrl}/evaluation/all`))
      .pipe(
        map((response: any, i) => {
          return <Evaluation[]>response;
        }),
        map(r => r.map(x => Evaluation.create(x))),
        tap(() => (this.loading = false))
      )
  }
}


@Injectable({
  providedIn: 'root'
})
export class EvaluationService extends CasiEvaluationService  {
  constructor(
    http: HttpClient,
    private apiService: ApiService
  ) {
    super(http)
  }

  get() {
    return this.apiService.getHttpCall('evaluation/all', 'get');
  }

  add(p: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise('evaluation', p, 'add');
  }

  update(id: number, dataItem: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`evaluation/${id}`, dataItem , 'update');
  }

  destroy(id: number): Promise<any> {
    return this.apiService.deleteHttpCallAsPromise(`evaluation/${id}` , 'destroy');
  }

  copy(dataItem: any): Promise<any> {
    const {id, evaluation_name} = dataItem;
    return this.apiService.postHttpCallAsPromise(`evaluation/copy`, {id, evaluation_name},'copy');
  }
}
